import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import isNil from 'utils/isNil';
import Hero from 'components/Playbook/Hero';
import Chapters from 'components/Playbook/Chapters';
import Cookies from 'js-cookie';
import { initPlaybookProgress } from 'components/Playbook/utils/mapData';
import useGlobalHeader from 'hooks/useGlobalHeader';
import WebsiteLayout from 'layouts/websiteLayout';
import SEO, { createSEO } from 'components/SEO';
import scroll from 'utils/smoothScroll';

const Playbook = props => {
  const header = useGlobalHeader();
  const seoData = props.data?.contentfulWebsitePage?.seo;
  const chapters = props.data?.contentfulWebsitePage?.components;
  const playbookProgress = Cookies.get('playbook_progress')
    ? JSON.parse(Cookies.get('playbook_progress'))
    : initPlaybookProgress();

  const { pageUrl } = seoData;

  const seo = createSEO(
    {
      ...seoData,
      pageCategory: 'Playbook',
    },
    props
  );
  useEffect(() => {
    scroll();
  }, []);

  const pageImages = props.data.allContentfulWebsiteImage;
  let heroBackground;
  let wrench;
  pageImages.edges.forEach(imageItem => {
    if (imageItem.node.internalName === 'contractor playbook hero') {
      heroBackground = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    } else if (imageItem.node.internalName === 'wrench-cutout') {
      wrench = !isNil(imageItem.node.image) ? imageItem.node.image.fluid.src : '';
    }
  });

  return (
    <WebsiteLayout header={header} background="White" heroFromTop landingPage>
      <SEO {...seo} />
      <Hero heroImg={heroBackground} wrench={wrench} />
      <Chapters splashPageSlug={pageUrl} chapters={chapters} progress={playbookProgress} />
    </WebsiteLayout>
  );
};
export default Playbook;

export const PlaybookDataQuery = graphql`
  query PlaybookDataQuery {
    contentfulWebsitePage(contentful_id: { eq: "1GwsdVOznKAOaXdM5irQHi" }) {
      seo {
        ...Seo
      }
      components {
        ... on ContentfulWebsiteContentBlock {
          title: heading
          sections: collection {
            ... on ContentfulRichText {
              title: sectionTitle
              slug: anchorId
            }
          }
          title: heading
          description: subhead {
            subhead
          }
        }
      }
    }
    allContentfulWebsiteImage(
      filter: {
        contentful_id: {
          in: [
            "zINh8e6Cw1eS2SwVfCdK9" #contractor playbook hero
            "56ieVipqfuwYPByTWmBZsY" #wrench-cutout
          ]
        }
      }
    ) {
      edges {
        node {
          internalName
          image {
            fluid(quality: 100) {
              ...GatsbyContentfulFluid_withWebp_noBase64
            }
          }
        }
      }
    }
  }
`;
